import { Subtitle, Title, TitleContainer, TitleWrapper } from './styles';

import React from 'react';
import { useIntl } from 'react-intl';

export const AvailabilityCalendarTitle = () => {
  const intl = useIntl();

  return (
    <TitleWrapper>
      <TitleContainer>
        <Title>{intl.formatMessage({ id: 'availability_title' })}</Title>
        <Subtitle>{intl.formatMessage({ id: 'availability_subtitle' })}</Subtitle>
      </TitleContainer>
    </TitleWrapper>
  );
};
